export enum MachineParamsField {
  Profile = 'profile',
  Games = 'games',
}
